

export const ACTION_GET_TOOL_BOOK_STATEMENT_LIST = 'ACTION_GET_TOOL_BOOK_STATEMENT_LIST';




// WEBPACK FOOTER //
// ./src/store/Admin/modules/semesterListIndex/types.js